import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import {
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { uploadDocumentRoute } from '../api/constant';
import { rockerboxDocumentsKey, rockerboxEmployerKey } from '../constants';

type useUploadDocumentProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useUploadDocument = ({
    setErrorText = () => { },
}: useUploadDocumentProps) => {
    const client = useQueryClient();

    const { mutate: uploadDocument, isLoading: isuploadDocumentLoading } =
        useMutation({
            mutationFn: (variables: {
                name: string;
                rockerbox_document: File | null;
                company_id: number | string
            }) => {
                const formData = new FormData();
                formData.append('name', variables.name);
                formData.append('rockerbox_document', variables.rockerbox_document ?? '');

                const url = `${uploadDocumentRoute}?company_id=${variables.company_id}`;

                return axiosInstance
                    .post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data);
            },
            onSuccess: (data) => {
                client.invalidateQueries([rockerboxDocumentsKey]);
                setErrorText('');
            },
            onError: () => {
                setErrorText(errorMessage);
            },
        });

    return {
        uploadDocument,
        isuploadDocumentLoading,
    };
};
